import * as React from "react";
import { connect } from "react-redux";
import styled, { keyframes } from "styled-components";

import { RootState } from "../../state";
import { Company, Image } from "../entities";
import { createEntitiesConsumer } from "../../lib/entities";
import ImageComponent from "../../common/components/Image";

interface MappedProps {
  company: Company;
}

interface MappedActions {
  baz(): void;
}

type Props = MappedProps & MappedActions;

const AvatarEnitiesConsumer = createEntitiesConsumer<{ avatar: Image }>({
  avatar: "images",
});

class CompanySpinnerContainer extends React.PureComponent<Props> {
  public render() {
    const { company } = this.props;
    return (
      <AvatarEnitiesConsumer query={{ avatar: company.avatar }}>
        {({ avatar }) => {
          return (
            <Wrapper>
              <Avatar image={avatar!} size="90x90m" lazy={false} />
            </Wrapper>
          );
        }}
      </AvatarEnitiesConsumer>
    );
  }
}

function mapStateToProps(state: RootState): MappedProps {
  return {
    company: state.companies.common.draftCompany!,
  };
}

export default connect(mapStateToProps)(CompanySpinnerContainer);

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  display: flex;
  min-height: 500px;
  align-items: center;
  justify-content: center;
`;

const Avatar = styled(ImageComponent)`
  display: block;
  width: 60px;
  height: 60px;
  border: solid 3px rgba(224, 224, 224, 1);
  border-radius: 50px;
  animation: ${rotate360} 1s ease infinite;
`;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/CompanySpinnerContainer.tsx